import { ICustomDocumentTypesMap, IEntityDocument, UUID } from "src/app/core/interfaces";

export namespace Documents {
  export class GetByIds {
    static readonly type = "[Documents] Get by IDs";
    constructor(public documentIds: UUID[]) { }
  }
  export class GetByIdsSuccess {
    static readonly type = "[Documents] Get by IDs Success";
    constructor(public documents: IEntityDocument[]) { }
  }
  export class GetByIdsFail {
    static readonly type = "[Documents] Get by IDs Fail";
    constructor(public error: unknown) { }
  }
  export class Create {
    static readonly type = "[Documents] Create";
    constructor(
      public documents: IEntityDocument[],
      public files: File[],
      public entityId: UUID,
      public documentTypeId: UUID,
      public orgId?: UUID,
    ) { }
  }
  export class CreateSuccess {
    static readonly type = "[Documents] Create Success";
    constructor(public documents: IEntityDocument[]) { }
  }
  export class CreateFail {
    static readonly type = "[Documents] Create Fail";
    constructor(public error: unknown) { }
  }
  export class Update {
    static readonly type = "[Documents] Update";
    constructor(public document: IEntityDocument) { }
  }
  export class UpdateSuccess {
    static readonly type = "[Documents] Update Success";
    constructor(public document: IEntityDocument) { }
  }
  export class UpdateFail {
    static readonly type = "[Documents] Update Fail";
    constructor(public error: unknown) { }
  }
  export class UploadVersion {
    static readonly type = "[Documents] Upload Version";
    constructor(public documentId: UUID, public file: File) { }
  }
  export class ManageVersionSuccess {
    static readonly type = "[Documents] Manage Version Success";
    constructor(public document: IEntityDocument) { }
  }
  export class ManageVersionFail {
    static readonly type = "[Documents] Manage Version Fail";
    constructor(public error: unknown) { }
  }
  export class DeleteVersion {
    static readonly type = "[Documents] Delete Version";
    constructor(public documentId: UUID, public versionIndex: number) { }
  }
  export class Delete {
    static readonly type = "[Documents] Delete";
    constructor(public document: IEntityDocument) { }
  }
  export class DeleteSuccess {
    static readonly type = "[Documents] Delete Success";
    constructor(public documentId: UUID) { }
  }
  export class DeleteFail {
    static readonly type = "[Documents] Delete Fail";
    constructor(public error: unknown) { }
  }
  export class GetCustomDocumentTypes {
    static readonly type = "[Documents] Get Custom Document Types";
    constructor(public orgId: UUID) { }
  }
  export class GetCustomDocumentTypesSuccess {
    static readonly type = "[Documents] Get Custom Document Types Success";
    constructor(public orgId: UUID, public customDocType: ICustomDocumentTypesMap) { }
  }
  export class GetCustomDocumentTypesFail {
    static readonly type = "[Documents] Get Custom Document Types Fail";
    constructor(public error: unknown) { }
  }
  export class SetCustomDocumentTypes {
    static readonly type = "[Documents] Set Custom Document Types";
    constructor(public orgId: UUID, public customDocType: ICustomDocumentTypesMap) { }
  }
  export class SetCustomDocumentTypesSuccess {
    static readonly type = "[Documents] Set Custom Document Types Success";
    constructor(public orgId: UUID, public customDocType: ICustomDocumentTypesMap) { }
  }
  export class SetCustomDocumentTypesFail {
    static readonly type = "[Documents] Set Custom Document Types Fail";
    constructor(public error: unknown) { }
  }
}
